$(document).ready(function() {
  const gridBreakpoint = 767;
  $(window).scroll(function() {
    var topScroll = $(window).scrollTop();
    if (topScroll < 1) {
      $('.banner').first().removeClass('scrolled');
      $('.product-navigation').removeClass('fixed');
    } else {
      $('.banner').first().addClass('scrolled');
      $('.product-navigation').addClass('fixed');
    }
    if ($(window).width() > gridBreakpoint && $('.toc-wrap').length !== 0 ) {
      if (topScroll > 150) {
        if (!$('.toc-wrap').hasClass('fixed')) {
          const tocTop = $('.banner').first().height() + $('.products-navigation').first().height();
          const tocLeft = $('.toc-wrap').first()[0].getBoundingClientRect().left;
          const tocWidth = $('.toc-wrap').first().width();
          $('.toc-wrap ').addClass('fixed');
          $('.toc-wrap').css({
            'top' : tocTop,
            'left' : tocLeft,
            'width' : tocWidth
          });
        }
      } else {
        $('.toc-wrap ').removeClass('fixed');
        $('.toc-wrap').removeAttr('style');
      }
    };
  })
  if ($('.docs-wrap').length !== 0) {
    const headlines = $('.section-content').find('h2');
    $('#menu-docs-menu').find('.current-menu-item').append('<ul class="child-menu"></ul>');
    $(headlines).each(function() {
      const headlineId = $(this).text().toLowerCase().replace(/[^\w ]+/g,'').replace(/ +/g,'-');
      $(this).attr('id', headlineId);
      $('#menu-docs-menu').find('.child-menu').append('<li><a class="scrollto" href="#'+headlineId+'">'+$(this).text()+'</a></li>');
    });
    $('.scrollto').on('click', function(e) {
      e.preventDefault();
      const scrollTarget = $(this).attr('href');
      $("html, body").animate({
        scrollTop: $(scrollTarget).offset().top - 90
      });
    });
  }

  if ($('#content_wrap').height() < $(window).height()) {
    const footerHeight = $('footer').outerHeight();
    $('#content_wrap').css({
      'minHeight' : $(window).height() - footerHeight
    });
  }
  $('.section-core').find('li').each(function() {
    $(this).prepend('<span class="material-icons">done</span> ');
  });

  if ($('.section-about').length && window.location.hash) {
    $("html, body").animate({
      scrollTop: $(window.location.hash).offset().top - 90
    });
  }


  if ($('.autosidebar').length !== 0) {
    const headlines = $('.page-content').find('h2');
    $('.autosidebar').html('<ul class="child-menu"></ul>');
    $(headlines).each(function() {
      const headlineId = $(this).text().toLowerCase().replace(/[^\w ]+/g,'').replace(/ +/g,'-');
      $(this).attr('id', headlineId);
      $('.autosidebar').find('.child-menu').append('<li><a class="scrollto" href="#'+headlineId+'">'+$(this).text()+'</a></li>');
    });
    $('.scrollto').on('click', function(e) {
      e.preventDefault();
      const scrollTarget = $(this).attr('href');
      $("html, body").animate({
        scrollTop: $(scrollTarget).offset().top - 90
      });
    });
  }

  $('#nav_wrap').on('hidden.bs.collapse', function () {
    $('body').removeClass('menu-visible');
    $('.banner').css('height', 'auto');
  });
  $('#nav_wrap').on('shown.bs.collapse', function () {
    $('body').addClass('menu-visible');
    $('.banner').css('height', $(window).height());
  });
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/custom.js
// module id = 2
// module chunks = 0